import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
import "normalize.css";
// 引入全局可用阿里图标样式文件
import './assets/font/iconfont.css'
// 引入全局可用阿里图标js文件
import './assets/font/iconfont.js'

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js